import { BaseViewBehavior } from "@quest/murka-games-behavior-panther";

export class HoldAndRespinIntroView extends BaseViewBehavior {
    
}